import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { armAnalytics, trackPageView } from "@/lib/analytics";

/**
 * Mount point for GA4. Renders nothing and, until the visitor interacts or the
 * browser goes idle, requests nothing — see src/lib/analytics.ts for why the
 * tag is gated that way.
 */
export function Analytics() {
  const href = useRouterState({ select: (s) => s.location.href });

  useEffect(() => armAnalytics(), []);

  // Client-side navigations don't reload the document, so GA4 needs an
  // explicit page_view per route change. No-op while the tag is still gated.
  useEffect(() => {
    trackPageView();
  }, [href]);

  return null;
}
